export default __webpack_public_path__ + "static/media/RW.0f7771b2.svg";